import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {shareReplay, tap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {ReputationHistory, ReputationRules, ReputationSummary} from './reputation.models';

@Injectable({providedIn: 'root'})
export class ReputationService {
  private readonly changed = new Subject<void>();
  public readonly changed$ = this.changed.asObservable();
  private readonly headers = new HttpHeaders({'x-cache-bypass': 'true'});
  public readonly rules$ = this.http.get<ReputationRules>(environment.apiUrl + '/reputation/rules', {headers: this.headers}).pipe(shareReplay({bufferSize: 1, refCount: false}));

  constructor(private readonly http: HttpClient) {}

  public summary(slug: string): Observable<ReputationSummary> {
    return this.http.get<ReputationSummary>(environment.apiUrl + '/users/' + encodeURIComponent(slug) + '/reputation', {headers: this.headers});
  }

  public history(page = 1, limit = 20): Observable<ReputationHistory> {
    return this.http.get<ReputationHistory>(environment.apiUrl + '/reputation/history', {params: {page, limit}, headers: this.headers});
  }

  public invalidate(): void { this.changed.next(); }

  public visit(): Observable<ReputationSummary> {
    return this.http.post<ReputationSummary>(environment.apiUrl + '/reputation/visit', {}, {headers: this.headers}).pipe(tap(() => this.invalidate()));
  }
}
